const AccountUpdateToastMessages = {
    defaultUpdated: 'addresses.defaultUpdated',
};

export default AccountUpdateToastMessages;
